import PropTypes from 'prop-types';

import * as Styled from './Carousel.styles';

function CarouselSlide({ children, slideIndex = 1, totalSlides = 1 }) {
  return (
    <Styled.Slide aria-label={`${slideIndex} of ${totalSlides}`} aria-roledescription="slide" role="group">
      {children}
    </Styled.Slide>
  );
}

CarouselSlide.propTypes = {
  slideIndex: PropTypes.number,
  totalSlides: PropTypes.number,
};

export default CarouselSlide;
